export const LabEducationConfig = [
    { span: 6, height: "27px" },
    {
        span: 6,
        height: "111px",
        classes: "marginTop-16",
    },
    { span: 6, height: "21px", classes: "marginTop-16" },
    { span: 6, height: "54px", classes: "marginTop-4" },
    {
        span: 6,
        height: "40px",
        classes: "marginTop-24",
    },
]
